var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "customer-reviews",
      style: { backgroundColor: _vm.backgroundColor }
    },
    [
      _c(
        "div",
        {
          staticClass: "customer-reviews__title",
          style: {
            fontSize: _vm.titleFontSize,
            lineHeight: _vm.titleLineHeight
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.sectionTitle
                  ? _vm.sectionTitle
                  : _vm.$t("paywall.customerReviewsTitle")
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "review-wrapper" },
        _vm._l(_vm.reviews, function(slide, i) {
          return _c(
            "div",
            {
              key: "Review_" + i,
              staticClass: "customer-reviews__content",
              class: _vm.showShadow && "shadow"
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "portrait" }, [
                    _c("div", { staticClass: "portrait__icon" }, [
                      _c("img", {
                        attrs: { src: "" + _vm.mediaBaseUrl + slide.image }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "portrait__text" }, [
                      _vm._v(_vm._s(slide.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "stars" },
                    _vm._l(slide.stars, function(star) {
                      return _c("img", {
                        key: "Swiper-Slide-Star_" + star,
                        staticClass: "stars__icon",
                        attrs: { src: _vm.mediaBaseUrl + "paywall/star.svg" }
                      })
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "content__text" }, [
                    _vm._v(_vm._s(slide.text))
                  ])
                ])
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }